import React from 'react'
import s from './Logotype.module.css'

const Logotype = () => {
  return (
    <div>
      <p className={s.logo}>AUQATRACK</p>
    </div>
  )
}

export default Logotype
